import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import { ApiService } from './api.service';
import { CognitoUtil } from './cognito.service';

@Injectable()
export class ReportsService {

    apiService: ApiService = new ApiService(this.http, this.cognito);

    reportsLink = environment.reports;

    constructor(
      private http: Http, private cognito: CognitoUtil
    ) { }

    getCaseStatusReports(orgId: string, userId): Observable<any>{
        return this.apiService.getCall('reports' , `organizations/${orgId}/user/${userId}/reports/CaseStatusPieChart`);
    }

    getCaseTypeReports(orgId: string, userId): Observable<any> {
        return this.apiService.getCall('reports' , `organizations/${orgId}/user/${userId}/reports/CaseType`);
    }

    getPaidCasesReports(orgId: string, userId): Observable<any> {
        return this.apiService.getCall('reports' , `organizations/${orgId}/user/${userId}/reports/IsPaid`);
    }

    getActiveCases(orgId: string, userId): Observable<any> {
        return this.apiService.getCall('reports' , `organizations/${orgId}/user/${userId}/reports/IsActive`);
    }

    getCalendarCases(orgId: string, userId): Observable<any> {
        return this.apiService.getCall('reports' , `organizations/${orgId}/user/${userId}/reports/CalendarCases`);
    }

    getCaseAgeInDays(orgId: string, userId): Observable<any> {
        return this.apiService.getCall('reports' , `organizations/${orgId}/user/${userId}/reports/CasesAgeInDays`);
    }

    getReportsCases(orgId, userId, reportName, item){
      return this.apiService.getCall('reports' , `organizations/${orgId}/user/${userId}/reports/${reportName}/${item}`);
    }

}



// WEBPACK FOOTER //
// ./src/app/main/shared/services/reports.service.ts